import PropTypes from 'prop-types';

import verificationStatusPropType from './verificationStatusPropType.js';

export const role = PropTypes.oneOf(['BUYER', 'SELLER']);
export const verificationUrl = PropTypes.string;

export default PropTypes.shape({
    role: role.isRequired,
    verificationStatus: verificationStatusPropType,
    verificationUrl,
    bankAccounts: PropTypes.arrayOf(
        PropTypes.shape({
            autoPayout: PropTypes.bool,
            accountNumber: PropTypes.string,
        })
    ),
});



// WEBPACK FOOTER //
// ./safeTrade/userPropTypes.js